<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopChange"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('adminProduct.queryCondition') }}</span>
          </div>
          <div class="">
            <el-form :inline="true" :model="adminProductInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-input v-model="adminProductInfo.conditions.prodName"
                  :placeholder="$t('adminProduct.inputProductName')" class="filter-item"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="_queryProductMethod()">{{ $t('adminProduct.query')
                  }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('adminProduct.onShelfProducts') }}</span>
          </div>
          <el-table :data="adminProductInfo.products" border style="width: 100%">
            <el-table-column prop="productId" :label="$t('adminProduct.productId')" align="center"></el-table-column>
            <el-table-column :label="$t('adminProduct.productImage')" align="center">
              <template slot-scope="scope">
                <img :src="scope.row.coverPhoto" style="width: 60px; height: 60px; border-radius: 5px;" />
              </template>
            </el-table-column>
            <el-table-column prop="categoryName" :label="$t('adminProduct.productGroup')"
              align="center"></el-table-column>
            <el-table-column prop="prodName" :label="$t('adminProduct.productName')" align="center"></el-table-column>
            <el-table-column prop="sales" :label="$t('adminProduct.sales')" align="center"></el-table-column>
            <el-table-column prop="stock" :label="$t('adminProduct.stock')" align="center"></el-table-column>
            <el-table-column prop="defaultSpecValue.price" :label="$t('adminProduct.price')"
              align="center"></el-table-column>
            <el-table-column prop="sort" :label="$t('adminProduct.sort')" align="center"></el-table-column>
            <el-table-column prop="stateName" :label="$t('adminProduct.status')" align="center"></el-table-column>
            <el-table-column prop="createTime" :label="$t('adminProduct.shelfTime')" align="center"></el-table-column>
            <el-table-column :label="$t('adminProduct.operation')" align="right" width="180">
              <template slot-scope="scope">
                <el-button size="mini" @click="_viewProductDetail(scope.row)">{{ $t('adminProduct.view') }}</el-button>
                <el-button size="mini" type="danger" @click="_openDeleteProductModel(scope.row)">{{
                  $t('adminProduct.delete') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next, jumper" :total="total" class="pagination"></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <delete-product ref="deleteProduct"></delete-product>
    <view-qrcode ref="qrcodeDialog" />

  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryAdminProduct } from '@/api/goods/adminProductApi'
import AdminShop from '@/components/shop/adminShop'
import DeleteProduct from '@/components/admin/deleteProduct/deleteProduct'
import ViewQrcode from '@/components/system/viewQrcode.vue'


export default {
  name: 'AdminProduct',
  components: {
    AdminShop,
    DeleteProduct,
    ViewQrcode

  },
  data() {
    return {
      shopId: '',
      adminProductInfo: {
        products: [],
        total: 0,
        records: 1,
        moreCondition: false,
        productId: '',
        conditions: {
          categoryId: '',
          state: '2002',
          prodName: '',
          keyword: '',
          barCode: '',
          shopId: ''
        },
        productCategorys: []
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.adminProductInfo.moreCondition)
    this._listAdminProducts(1, 10)
  },
  methods: {
    handleShopChange(shop) {
      this.adminProductInfo.conditions.shopId = shop.shopId
      this._listAdminProducts(1, 10)
    },
    async _listAdminProducts(page, rows) {
      this.adminProductInfo.conditions.page = page
      this.adminProductInfo.conditions.row = rows
      try {
        const res = await queryAdminProduct(this.adminProductInfo.conditions)
        this.adminProductInfo.total = res.total
        this.adminProductInfo.records = res.records
        this.adminProductInfo.products = res.data
        this.total = res.records
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openDeleteProductModel(product) {
      this.$refs.deleteProduct.open(product)
    },
    _queryProductMethod() {
      this._listAdminProducts(1, 10)
    },
    _viewProductDetail(product) {
      // this.$emit('viewQrCode', {
      //   title: product.prodName,
      //   url: product.pageUrl,
      //   remark: '手机扫码查看商品'
      // })
      const qrcodeData = {
        qrcodeName: product.prodName,
        qrCodeUrl:  product.pageUrl,
        remark: '手机扫码查看商品'
      }
      this.$refs.qrcodeDialog.open(qrcodeData)
    },
    handleCurrentChange(val) {
      this._listAdminProducts(val, 10)
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.filter-container {
  padding-bottom: 10px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>